import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const CybusMinimalLogo: FC<SvgIconProps> = (props) => (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
        <g clipPath="url(#clip0_3291_2184)">
            <path d="M6.64209 8.87653L12.3976 18.1043H9.06008L2.4 9.09407V8.65898L9.06008 -0.350586H12.3976L6.64209 8.87653Z" fill="#F5A119" />
            <path d="M17.3716 15.1087L11.6018 5.89502H14.9393L21.6 14.9059V15.341L14.9393 24.3505H11.6018L17.3716 15.1087Z" fill="#F5A119" />
        </g>
        <defs>
            <clipPath id="clip0_3291_2184">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </SvgIcon>
)
